import * as actionTypes from './actionTypes';

export const getUserClaims = (userLogin) => {
    return {
      type: actionTypes.GET_USER_CLAIMS,
      userLogin: userLogin
    };
  };